import 'react-calendar/dist/Calendar.css';
import './App.css';
import { Slideshow, CustomSlideSize, ChooseImageType } from './Slideshow.js';
import { getImages, imgArr, parseImgToDate, getImagesByType } from './ImageFunctions.js';
import { Cal, Files } from './Calendar.js';
import { useState, useReducer, useEffect } from 'react';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [arrExists, setArrExists] = useState(true);
  let [imgs, setImgs] = useState(null);
  let [dateFromCal, setDateFromCal] = useState(new Date());
  let [allImages, setAllImages] = useState(null);
  let [imagesByType, setImgsByType] = useState(null);
  let [calDates, setCalDates] = useState(new Date());
  let [slideSize, setSlideSize] = useState(5);
  let [photoType, setPhotoType] = useState("qc");
  let [currentIndex, setCurrentIndex] = useState();
  let dates = [];

  useEffect(() => {
    async function getData() {
      setIsLoading(true);

      try {
        const res = await fetch("/par/php-backend/");
        const data = await res.json();

        setAllImages(data);
        setCurrentIndex(Object.values(data).length - 4);

        Object.values(data).forEach(img => {
          let datedImg = parseImgToDate(img);
          if(!dates.includes(datedImg)) {
            dates.push(datedImg);
          }
        });
        setCalDates(dates);
      } catch(error) {
        console.error('Error fetching data: ', error);
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  },[]);

  function handleDataFromCalendar(data) {
    setDateFromCal(data);
    console.log(data);
    let type = data.substring(data.length, data.length - 6);
    console.log(type);
  }

  function handleDataFromFiles(data) {
    setCurrentIndex(data);
  }
  
  function handleArraySize(data) { 
    setSlideSize(data);
  }

  function handlePhotoType(data) {
    setPhotoType(data);
  }

  function handleLastImageButton(data) {
    if(data === "1") {
      setCurrentIndex(Object.values(allImages).length + 1);
      console.log(currentIndex);
    }
  }


  return (
    
    <div className="App data-display">
      {
        isLoading ? (
          <p className='whiteText' style={{maxWidth: '1200px', maxHeight: '1200px'}}>Loading...</p>
        ):
        allImages ? (
          <>
            
            <div className='image-slideshow'>
                {arrExists ? (
                    <Slideshow images={allImages} size={slideSize} type={photoType} index={currentIndex} interval={1000} thumbnailId={"slideshow"} playStopId={"Play"} sendLastImgMessageToParent={handleLastImageButton} />
                  ):(
                    <p className='whiteText' style={{width: '1200px', height: '300px', display: 'block'}}>No Data</p>
                )}
              
              <div >
                <CustomSlideSize sendArraySizetoParent={handleArraySize} />
                <ChooseImageType type={photoType} sendPhotoTypetoParent={handlePhotoType} />
              </div>
            </div>
            <div className='calendar'>
              <Cal sendDataToParent={handleDataFromCalendar} imgDates={calDates} />
              <Files date={dateFromCal} files={Object.values(allImages)} sendDataToParent={handleDataFromFiles} />
            </div>
          </>
        ): 
        (
          <p>No data available</p>
        )
      }
    </div>
  );
}

export default App;
